
import React from 'react';
import CardContenedor from "../components/CardContenedor";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import { Volver } from '../components/Volver'
import { Button, Modal, Spinner } from "react-bootstrap";
import useHistorialComisiones from "../hooks/useHistorialComisiones";
import DataTable from 'react-data-table-component';


export default function HistorialComisiones({ fromAdmin = false }) {

    const { listaHistorial, cargando, show, handleClose, formComision, formDestino,
        formOrigen, setFormComision, setFormDestino, setFormOrigen, columns,
		elementosFiltrados, buscar, setBuscar } = useHistorialComisiones(fromAdmin)
    const objLogueado = useEmpleadoStore(state => state.objLogueado)


    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }



    const TextPermisos = () => {
        if (elementosFiltrados.length === 0) {
            return <p className="lead py-2">No hay historial de comisiones</p>
        } else if (elementosFiltrados.length === 1) {
            return <p className="lead py-2">Mostrando 1 registro</p>
        } else {
            return <p className="lead py-2">Mostrando {elementosFiltrados.length} registros</p>
        }
    }




    const ComponenteGrandote = () => {
        return <>

        </>
    }


    // if (fromAdmin) {
    //     return <ComponenteGrandote/>
    // }


    return (
        <CardContenedor>

            <Volver />
            <ComponenteGrandote/>

            <div>
                {cargando && <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>}
            </div>

            <TextPermisos />


			<input
				type='search'
				value={buscar}
				className='form-control mb-2'
				onChange={ e => setBuscar(e.target.value) }
				placeholder='Buscar por nombre o motivo'
			/>



			{ listaHistorial.length > 0
				&& (<DataTable
					dense
					responsive
					pagination
					columns={columns}
					data={elementosFiltrados}
                    noDataComponent='No hay datos para mostrar'
                    progressPending={cargando}
                    highlightOnHover
                    paginationComponentOptions={{
                        rowsPerPageText: 'Filas por página:',
                        rangeSeparatorText: 'de',
                        selectAllRowsItem: true,
                        selectAllRowsItemText: 'Todos',
                        pageText: 'Página'
                    }}
				/> || <p className='lead text-center'>No hay datos para mostrar</p>) }






            <Modal
                size="lg"
                show={show}
                onHide={handleClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Detalle de comisión</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {/* nombre */}
                    <div className='mb-2 mt-4 row d-flex flex-row'>
                        <div className='col-12 col-md-5 text-end'>
                            <b>Nombre:</b>
                        </div>
                        <div className='col-12 col-md-7'>
                            {objLogueado.nombre} {objLogueado.apellido}
                        </div>
                    </div>

                    {/* dependencia */}
                    <div className='mb-2 row d-flex flex-row'>
                        <div className='col-12 col-md-5 text-end'>
                            <b>Área o dependencia administrativa:</b>
                        </div>
                        <div className='col-12 col-md-7'>
                            {formComision.areas_adscripcion}
                        </div>
                    </div>

                    {/* puesto */}
                    <div className='mb-2 row d-flex flex-row'>
                        <div className='col-12 col-md-5 text-end'>
                            <b>Puesto:</b>
                        </div>
                        <div className='col-12 col-md-7'>
                            {formComision.puesto}
                        </div>
                    </div>

                    <div className='mb-2 row d-flex flex-row'>

                        {/* motivo */}
                        <div className='col-12 col-md-5 text-end'>
                            <b>Motivo de la comisión:</b>
                        </div>
                        <div className='col-12 col-md-7'>
                            <textarea
                                rows="3"
                                maxLength="255"
                                className="form-control"
                                placeholder='Escriba el motivo'
                                defaultValue={formComision.motivo}
								readOnly
                                id="exampleFormControlTextarea1"
                                onChange={({ target: { value: motivo } }) => setFormComision({ ...formComision, motivo })}
                            >
                                {/* { formSalida.motivo && '' } */}
                            </textarea>
                        </div>


                        <div className='mb-2 row d-flex flex-row'>
                            <div className='col-12'>

                                {/* origen */}
                                <hr className="mt-5" />
                                <table className='table table-sm text-center table-borderless'>
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>Origen del encargo o comision</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>País</td>
                                            <td>Estado</td>
                                            <td>Ciudad</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formOrigen.pais}
													readOnly
                                                    onChange={e => setFormOrigen({ ...formOrigen, pais: e.target.value })}
                                                />
                                            </td>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formOrigen.estado}
													readOnly
                                                    onChange={e => setFormOrigen({ ...formOrigen, estado: e.target.value })}
                                                />
                                            </td>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formOrigen.ciudad}
													readOnly
                                                    onChange={e => setFormOrigen({ ...formOrigen, ciudad: e.target.value })}
                                                />
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>


                                {/* destino */}
                                <hr className="mt-5" />
                                <table className='table table-sm text-center table-borderless'>
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>Destino del encargo o comision</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>País</td>
                                            <td>Estado</td>
                                            <td>Ciudad</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formDestino.pais}
													readOnly
                                                    onChange={e => setFormDestino({ ...formDestino, pais: e.target.value })}
                                                />
                                            </td>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formDestino.estado}
													readOnly
                                                    onChange={e => setFormDestino({ ...formDestino, estado: e.target.value })}
                                                />
                                            </td>
                                            <td>
                                                <input type="text" className="form-control" placeholder='Escribe aquí'
                                                    value={formDestino.ciudad}
													readOnly
                                                    onChange={e => setFormDestino({ ...formDestino, ciudad: e.target.value })}
                                                />
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>


                                {/* fechas de salida y regreso */}
                                <hr className="mt-5" />
                                <div className="row gx-4 gy-3">
                                    <div className="col-md">
                                        <div className="mb-3">
                                            <label htmlFor="fecha_salida" className="fw-bold text-end">Fecha de salida</label>
                                            <input
                                                type="date"
                                                className="form-control"
												readOnly
												id="fecha_salida"
                                                value={formComision.fecha_salida}
                                                onChange={e => setFormComision({ ...formComision, fecha_salida: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="mb-3">
                                            <label htmlFor="fecha_regreso" className="fw-bold text-end">Fecha de regreso</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="fecha_regreso"
												readOnly
                                                value={formComision.fecha_regreso}
                                                onChange={e => setFormComision({ ...formComision, fecha_regreso: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row gx-4 gy-3">
                                    {/* tipo de viaticos */}
                                    <div className="col-md">
                                        <div className="mb-3">
                                            <label htmlFor="tipo_viatico" className="fw-bold text-end">Tipo de viáticos</label>
                                            <select id="tipo_viatico" className='form-control' defaultValue={formComision.tipo_viatico} onChange={e => setFormComision({ ...formComision, tipo_viaticos: e.target.value })}>
                                                <option value={0} disabled>Selecciona una opción</option>
                                                <option value="Anticipados">Anticipados</option>
                                                <option value="Devengados">Devengados</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* vehículo autorizado */}
                                    <div className="col-md">
                                        <div className="mb-3">
                                            <label htmlFor="vehiculo_autorizado" className="fw-bold text-end">Vehículo autorizado</label>
                                            <input
                                                type="text"
												readOnly
                                                id="vehiculo_autorizado"
                                                className="form-control"
                                                placeholder="Completa este campo"
                                                value={formComision.vehiculo_autorizado}
                                                onChange={e => setFormComision({ ...formComision, vehiculo_autorizado: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row gx-4 gy-3">
                                    <div className="col-md">
                                        {/* combustible */}
                                        <div className="mb-3">
                                            <label htmlFor="combustible" className="fw-bold text-end">Combustible</label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text" id="basic-addon1">$</span>
                                                <input
                                                    type="text"
													readOnly
                                                    id="combustible"
                                                    className="form-control"
                                                    aria-label="combustible"
                                                    aria-describedby="basic-addon1"
                                                    value={formComision.combustible}
                                                    placeholder="Completa este campo"
                                                    onChange={e => setFormComision({ ...formComision, combustible: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md">

                                        {/* litros */}
                                        <div className="mb-3">
                                            <label htmlFor="litros" className="fw-bold text-end">Litros</label>
                                            <input
                                                type="text"
												readOnly
                                                id="litros"
                                                className="form-control"
                                                placeholder="Completa este campo"
                                                value={formComision.litros}
                                                onChange={e => setFormComision({ ...formComision, litros: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="row gx-4 gy-3">
                                    <div className="col-md">
                                        {/* placas */}
                                        <div className="mb-3">
                                            <label htmlFor="placas" className="fw-bold text-end">Placas</label>
                                            <input
                                                type="text"
                                                id="placas"
												readOnly
                                                className="form-control"
                                                placeholder="Completa este campo"
                                                value={formComision.placas}
                                                onChange={e => setFormComision({ ...formComision, placas: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md"></div>
                                </div>
                                {/* aquí termina el formulario */}

                                <div className="text-center">

                                    {/* <button className="btn btn-primary btn-block btn-lg" onClick={guardar} disabled={guardando}>
                                        {guardando ? 'Guardando' : 'Generar oficio'}
                                    </button> */}
                                </div>

                            </div>


                        </div>
                    </div>


                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

        </CardContenedor>
    )
}
